<script setup>
import CartePrevisionRestaurationJour from '@/components/etablissement/restauration/carte-prevision-restauration-jour.vue'
</script>
<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-btn icon color="secondary" @click="jumpBack4dates">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-col cols="3">
        <v-menu
          v-if="renderDatePicker"
          v-model="menuDates"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          nudge-top="12"
          nudge-left="8"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              clearable
              dense
              v-model="dates"
              label="Dates de prévisions"
              readonly
              hide-details
              v-bind="attrs"
              v-on="on"
              :loading="loadingCount > 0"
              color="primary"
              @click:clear="clearDates"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dates"
            range
            :min="dates[0]"
            :max="dateAPlus4jours"
            first-day-of-week="1"
            locale="fr"
            @change="
              () => {
                menuDates = false
                refreshPrevision()
              }
            "
          />
        </v-menu>
      </v-col>
      <v-btn icon color="secondary" @click="jump4dates">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" lg="3" v-for="(previsionJour, i) in sortedPrevi" :key="i">
        <carte-prevision-restauration-jour :prevision-jour="previsionJour.prevision" :date="previsionJour.date" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { nextTick } from 'vue'
import moment from 'moment/moment'

export default {
  name: 'pevisionnel-restauration',
  props: {
    etablissementId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      renderDatePicker: true,
      menuDates: false,
      loadingCount: false,
      dates: [moment().format('YYYY-MM-DD'), moment().add(3, 'd').format('YYYY-MM-DD')],
      previ: [],
    }
  },
  computed: {
    ...mapGetters({
      datesCompriseEntreDeuxDatesInclues: 'calendrier/datesCompriseEntreDeuxDatesInclues',
    }),
    allDates() {
      return this.datesCompriseEntreDeuxDatesInclues(this.dates[0], this.dates[1])
    },
    dateAPlus4jours() {
      return this.dates[0] ? moment(this.dates[0]).add(3, 'd').format('YYYY-MM-DD') : undefined
    },
    sortedPrevi() {
      return this.previ ? this.previ.sort((a, b) => a.date > b.date) : []
    },
  },
  mounted() {
    this.refreshPrevision()
  },
  methods: {
    ...mapActions({
      obtenirPrevisionPourDate: 'etablissement/obtenirPrevisionsRepasPourDate',
    }),
    clearDates() {
      this.dates = []
      this.previ = []
      this.forceRender()
    },
    jumpBack4dates() {
      this.dates = [
        moment(this.dates[0]).subtract(4, 'd').format('YYYY-MM-DD'),
        moment(this.dates[1]).subtract(4, 'd').format('YYYY-MM-DD'),
      ]
      this.refreshPrevision()
    },
    jump4dates() {
      this.dates = [
        moment(this.dates[0]).add(4, 'd').format('YYYY-MM-DD'),
        moment(this.dates[1]).add(4, 'd').format('YYYY-MM-DD'),
      ]
      this.refreshPrevision()
    },
    async forceRender() {
      this.renderDatePicker = false
      await nextTick()
      this.renderDatePicker = true
    },
    refreshPrevision() {
      console.log('refreshing with', this.allDates)
      this.loadingCount = this.allDates.length
      this.previ = []
      for (const date of this.allDates) {
        this.obtenirPrevisionPourDate({
          etablissementId: this.etablissementId,
          dateDeProspection: date,
        }).then((prevision) => {
          this.previ.push({
            date: date,
            prevision,
          })
          this.loadingCount -= 1
        })
      }
    },
  },
}
</script>
